// store/admin/question-bank/store/_reducer.js
import * as types from './_actionTypes';

const initialState = {
  questions: [],
  selectedCourse: null,
  selectedQuestion: null,
  loading: false,
  error: null,
  success: null
};

const questionBankReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create single question
    case types.CREATE_QUESTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.CREATE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: [action.payload, ...state.questions],
        success: 'Question created successfully',
        error: null
      };
    case types.CREATE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Bulk create questions
    case types.BULK_CREATE_QUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.BULK_CREATE_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: [...action.payload, ...state.questions],
        success: `${action.payload.length} questions created successfully`,
        error: null
      };
    case types.BULK_CREATE_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Get questions by course
    case types.GET_QUESTIONS_BY_COURSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.GET_QUESTIONS_BY_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: action.payload,
        error: null
      };
    case types.GET_QUESTIONS_BY_COURSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        questions: []
      };

    // Update question
    case types.UPDATE_QUESTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    case types.UPDATE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: state.questions.map(question =>
          question.id === action.payload.id ? action.payload : question
        ),
        selectedQuestion: action.payload,
        success: 'Question updated successfully',
        error: null
      };
    case types.UPDATE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    // Delete question
    case types.DELETE_QUESTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.DELETE_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: state.questions.filter(question => question.id !== action.payload),
        success: 'Question deleted successfully',
        error: null
      };
    case types.DELETE_QUESTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Bulk delete questions
    case types.BULK_DELETE_QUESTIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.BULK_DELETE_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: state.questions.filter(q => !action.payload.includes(q.id)),
        success: `${action.payload.length} question(s) deleted successfully`,
        error: null,
      };
    case types.BULK_DELETE_QUESTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Local state management
    case types.SET_SELECTED_COURSE:
      return {
        ...state,
        selectedCourse: action.payload,
        questions: [] // Clear questions when course changes
      };
    case types.SET_SELECTED_QUESTION:
      return {
        ...state,
        selectedQuestion: action.payload
      };
    case types.CLEAR_QUESTION_BANK_ERROR:
      return {
        ...state,
        error: null
      };
    case types.CLEAR_QUESTION_BANK_SUCCESS:
      return {
        ...state,
        success: null
      };
    case types.RESET_QUESTION_BANK:
      return initialState;

    default:
      return state;
  }
};

export default questionBankReducer;
